import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Document: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.984 7.992V15.984H1.992H0V19.992V24H10.008H20.016V16.008V8.016H22.008H24V4.008V0H13.992H3.984V7.992ZM6 9V15.984H11.004H16.008V18V20.016H15H13.992V19.008V18H8.004H2.016V19.992V21.984H10.008H18V12.9837V3.98347L19.002 3.98974L20.004 3.996L20.0103 4.998L20.0165 6H21.0003H21.984V4.008V2.016H13.992H6V9ZM7.992 7.008V8.016H12H16.008V7.008V6H12H7.992V7.008ZM7.992 10.992V12H12H16.008V10.992V9.984H12H7.992V10.992Z'
        fill={fill}
      />
    </svg>
  )
}

export default Document
